<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_2358_66273" :fill="bgFill">
      <rect height="16" rx="1" width="24" y="4"/>
    </mask>
    <rect height="16" mask="url(#path-1-inside-1_2358_66273)" rx="1" :stroke="fill" stroke-linejoin="round" stroke-width="4" width="24" y="4"/>
    <path d="M2 6L12 12L22 6" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>

</template>

<script>
export default {
  name: 'Email',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
    bgFill: {
      type: String,
      required: false,
      default: '#FFF'
    },
  },
};

</script>
